import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, Fragment as _Fragment, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-08893c87"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "details-box"
};
const _hoisted_2 = /*#__PURE__*/_createTextVNode("获取支付结果...");
const _hoisted_3 = {
  key: 0,
  class: "card"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "点击拆卡", -1));
const _hoisted_5 = [_hoisted_4];
const _hoisted_6 = {
  class: "product"
};
const _hoisted_7 = {
  class: "price"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://p6.moimg.net/mdwxapp/pay/mall_pay_success_goods_animation_icon.png",
  alt: "",
  class: "gogif"
}, null, -1));
const _hoisted_9 = {
  class: "mall-bottom-info"
};
const _hoisted_10 = {
  class: "bt-box"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://p6.moimg.net/mdwxapp/pay/mall_pay_success_order_icon.png",
  alt: ""
}, null, -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "查看订单", -1));
const _hoisted_13 = [_hoisted_11, _hoisted_12];
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://p6.moimg.net/mdwxapp/pay/mall_pay_success_home_icon.png",
  alt: ""
}, null, -1));
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "返回商城", -1));
const _hoisted_16 = [_hoisted_14, _hoisted_15];
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://p6.moimg.net/mdwxapp/pay/mall_pay_success_score_icon.png",
  alt: "",
  class: "ji"
}, null, -1));
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://p6.moimg.net/mdwxapp/pay/mall_pay_success_arrow_icon.png",
  alt: "",
  class: "arrow"
}, null, -1));
const _hoisted_19 = {
  key: 0,
  class: "hotproject"
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://p6.moimg.net/mdwxapp/pay/mall_pay_success_back.png",
  alt: "",
  class: "product bg"
}, null, -1));
const _hoisted_21 = {
  class: "content"
};
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://p6.moimg.net/mdwxapp/pay/pro_pay_success_prize_icon.png",
  alt: "",
  class: "jiangbei"
}, null, -1));
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, "成功支持", -1));
const _hoisted_24 = {
  class: "price"
};
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://p6.moimg.net/mdwxapp/pay/pro_pay_success_score_icon.png",
  alt: "",
  class: "ji"
}, null, -1));
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://p6.moimg.net/mdwxapp/pay/pro_pay_success_arrow_icon.png",
  alt: "",
  class: "arrow"
}, null, -1));
const _hoisted_27 = {
  key: 2,
  class: "cont-cp"
};
const _hoisted_28 = {
  class: "cpicon"
};
const _hoisted_29 = ["src"];
const _hoisted_30 = {
  class: "cpname"
};
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cpmesage"
}, "“感谢你的支持，我们会更加努力！”", -1));
const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://p6.moimg.net/mdwxapp/pay/pro_pay_success_back.png",
  alt: "",
  class: "bg"
}, null, -1));
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icon"
}, null, -1));
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "快来摩点 APP", -1));
const _hoisted_35 = {
  key: 0
};
const _hoisted_36 = {
  key: 1
};
const _hoisted_37 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "更有 APP 专享优惠券等你来拿!", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_loading = _resolveComponent("van-loading");
  const _component_main_content = _resolveComponent("main-content");
  return _openBlock(), _createElementBlock("div", null, [$data.payinfoSuccess == false ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_loading, {
    size: "24px",
    color: "#00cba6"
  }, {
    default: _withCtx(() => [_hoisted_2]),
    _: 1
  })])) : $data.payinfoData.pay_status == 2 ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [$data.cardInfo && $data.cardInfo.extract_card_id ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", {
    class: "button",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.toCardPrize && $options.toCardPrize(...args))
  }, _hoisted_5)])) : $data.payinfoData.order_type == 4 ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("span", null, _toDisplayString($data.payinfoData.pay_amount ? "¥" + $data.payinfoData.pay_amount : ""), 1), _createElementVNode("span", null, _toDisplayString($data.payinfoData.pay_amount && $data.payinfoData.pay_point ? "+" : ""), 1), _createElementVNode("span", null, _toDisplayString($data.payinfoData.pay_point ? $data.payinfoData.pay_point + "积分" : ""), 1)]), _hoisted_8, _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [$data.payinfoData.order_id ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "bt",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.toMallOrderDetail && $options.toMallOrderDetail(...args))
  }, _hoisted_13)) : _createCommentVNode("", true), _createElementVNode("div", {
    class: "bt",
    onClick: _cache[2] || (_cache[2] = (...args) => $options.toShop && $options.toShop(...args))
  }, _hoisted_16)]), $data.payinfoData.point ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "cont-bt",
    onClick: _cache[3] || (_cache[3] = (...args) => $options.toScore && $options.toScore(...args))
  }, [_hoisted_17, _createElementVNode("span", null, "获得积分 " + _toDisplayString($data.payinfoData.point), 1), _hoisted_18])) : _createCommentVNode("", true)]), $data.feed_params_string != '' ? (_openBlock(), _createElementBlock("div", _hoisted_19, " · 猜你喜欢 · ")) : _createCommentVNode("", true), $data.feed_params_string != '' ? (_openBlock(), _createBlock(_component_main_content, {
    key: 1,
    ad_position: "mall_page_recommend",
    params_string: $data.feed_params_string
  }, null, 8, ["params_string"])) : _createCommentVNode("", true)]), _hoisted_20], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 2
  }, [_createElementVNode("div", _hoisted_21, [$data.payinfoData.order_id ? (_openBlock(), _createElementBlock("text", {
    key: 0,
    class: "order-info",
    onClick: _cache[4] || (_cache[4] = (...args) => $options.toProOrderDetail && $options.toProOrderDetail(...args))
  }, "订单详情")) : _createCommentVNode("", true), _hoisted_22, _hoisted_23, _createElementVNode("div", _hoisted_24, "¥" + _toDisplayString($data.payinfoData.pay_amount), 1), $data.payinfoData.point ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "cont-bt",
    onClick: _cache[5] || (_cache[5] = (...args) => $options.toScore && $options.toScore(...args))
  }, [_hoisted_25, _createElementVNode("span", null, "获得积分 " + _toDisplayString($data.payinfoData.point), 1), _hoisted_26])) : _createCommentVNode("", true), $data.cpinfoData.user_info ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_createElementVNode("img", {
    src: $data.cpinfoData.user_info.icon,
    alt: ""
  }, null, 8, _hoisted_29)]), _createElementVNode("div", _hoisted_30, _toDisplayString($data.cpinfoData.user_info.nickname || $data.cpinfoData.user_info.username), 1), _hoisted_31])) : _createCommentVNode("", true)]), _hoisted_32], 64)), $data.downloadShow ? (_openBlock(), _createElementBlock("div", {
    key: 3,
    class: "download",
    onClick: _cache[9] || (_cache[9] = $event => $data.downloadShow = false)
  }, [_createElementVNode("div", {
    class: "dialog",
    onClick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"]))
  }, [_createElementVNode("span", {
    class: "close-icon iconfont icon-close",
    onClick: _cache[6] || (_cache[6] = $event => $data.downloadShow = false)
  }), _hoisted_33, _hoisted_34, $data.payinfoData.order_type != 4 ? (_openBlock(), _createElementBlock("p", _hoisted_35, "第一时间接收项目的更新动态～")) : (_openBlock(), _createElementBlock("p", _hoisted_36, "接收实时物流通知～")), _createElementVNode("div", {
    class: "downbtn",
    onClick: _cache[7] || (_cache[7] = _withModifiers((...args) => $options.openLink && $options.openLink(...args), ["stop"]))
  }, "前往摩点 APP"), _hoisted_37])])) : _createCommentVNode("", true)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 2
  }, [], 64))]);
}